import React from "react";
import Select from "react-select";
import "react-select/dist/react-select.css";

class ReactSelect extends React.Component {
  state = {
    selectedOption: null
  };
  handleChange = selectedOption => {
    const {handleSelect} = this.props;
    handleSelect(selectedOption, "multi");
    this.setState({ selectedOption });
  };

  render() {
    const { selectedOption } = this.state;
    const { allSchemas,state_key} = this.props;
    const options = [];
    allSchemas &&
    allSchemas.map(data => {
        options.push({
          value: data.name,
          label: data.name,
          id: data.id,
          key: state_key
        });
        return data;
      });
    return (
      <Select
        clearable
        value={selectedOption}
        multi
        onChange={this.handleChange}
        options={options}
      />
    );
  }
}

export default ReactSelect;



// WEBPACK FOOTER //
// ./src/views/FinancicalStructure/FinancicalStructure/Multiselect.js